import AuthHeader from "components/Headers/AuthHeader.jsx";
import AuthFooter from "components/Footers/AuthFooter";
import Constants from "utils/Constants";
import CloudList from "./CloudList";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import SkeletonLoader from "elements/SkeletonLoader";
import AppHelmet from "../../components/AppComponents/AppHelmet";
import { useNavigate } from "react-router-dom";
import AdminNavbarNoModule from "../../components/Navbars/AdminNavbarNoModule";
import useClouds from "../../api/api-hooks/cloud/useClouds";

const CloudListView = () => {
  const navigate = useNavigate();
  let { clouds, cloudsLoading } = useClouds();

  return (
    <>
      <AppHelmet title="Select A Cloud - GrowthCloud.com" />
      <div className="main-content" style={{ minHeight: "calc(100vh - 90px)" }}>
        <AdminNavbarNoModule
          theme="dark"
          module={Constants.MODULES.SUPPORTAL}
        />
        <div className="pt-4 pt-sm-0">
          <AuthHeader
            title="Select A Cloud"
            lead="Launch a cloud instance to continue."
          />
        </div>
        <Container className="pb-5 mt--5">
          {cloudsLoading ? (
            <div>
              <Row className="justify-content-center">
                <Col lg={"8"} xl={"7"} md={"10"}>
                  <SkeletonLoader css="mx-2" height={150} />
                </Col>
              </Row>
            </div>
          ) : (
            <>
              {clouds?.length > 0 && (
                <Row className="justify-content-center">
                  <Col lg={"8"} xl={"7 "} md={"10"}>
                    <Card className="bg-white shadow-sm border border-superlight mb-0">
                      <CardHeader className="bg-transparent pb-3">
                        <Row className="align-items-center">
                          <Col>
                            <h3 className="m-0 mb-0 p-0">Your Clouds</h3>
                            <p className="m-0" style={{ lineHeight: 1.2 }}>
                              <small className="m-0 p-0">
                                Launch an existing GrowthCloud
                              </small>
                            </p>
                          </Col>
                        </Row>
                      </CardHeader>
                      <CardBody className="p-0">
                        <CloudList isDrawer={false} favoritesEnabled={true} />
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              )}
            </>
          )}

          <Row className="justify-content-center mt-4">
            <Col lg={"8"} xl={"7 "} md={"10"}>
              {!cloudsLoading && clouds?.length > 0 && (
                <hr className="mt-1 mb-4"></hr>
              )}
              <Card className="bg-white shadow-sm border border-superlight mb-0">
                <CardBody className="bg-transparent px-4 py-3">
                  <Row className="align-items-center">
                    <Col>
                      <h3 className="m-0 mb-0 p-0">Create A Cloud</h3>
                      <p className="m-0" style={{ lineHeight: 1.2 }}>
                        <small>
                          Create a new GrowthCloud for your organization
                        </small>
                      </p>
                    </Col>
                    <Col xs="auto">
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => navigate("/create/cloud")}
                      >
                        New Cloud
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Container fluid>
        <AuthFooter />
      </Container>
    </>
  );
};

export default CloudListView;
